import uiRouter from 'angular-ui-router';
import './privilege.scss';
var module = angular.module('PrivilegeDashboard', [
    uiRouter

]);

import privDashboardTpl from './views/privilegeDashboard.html';
import privDashboardCtrl from './controllers/privilegeDashboardController';
import './privilege.scss';
import privSettingsTpl from './views/privilegeSettings.html';
import privSettingsCtrl from './controllers/privilegeSettingsController';

import _ from "underscore"

module.constant('PRIVILEGECONSTANT', {
    API_GET_MODULE_LIST: "/v0/privilege/get-all-modules/",
    API_SET_PRIVILEGE_DEFAULT: "/v0/privilege/set-selected-privilege-default",
    API_UPDATE_PRIVILEGE: "/v0/privilege/update-features"
})


module.config(function($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider
        .state('privilegeDashboard', {
            parent: 'app',
            url: '/privilege/main-page',
            views: {
                '@': {
                    template: privDashboardTpl,
                    controller: privDashboardCtrl,
                    controllerAs: 'privilegeDashboard'
                }
            }
        })
});



var module = angular.module('PrivilegeSettings', [
    uiRouter

]);
module.constant('PRIVSETTINGSCONSTANT', {
    API_GET_ALL_ROLES: "/v0/initial-settings/user-console/roles/added/",
    API_GET_MODULE_LIST: "/v0/privilege/get-all-modules/",
    API_CHECK_PRIVILEGE_EXISTS: "/v0/privilege/check-if-privilege-exits",
    API_SET_PRIVILEGE_DEFAULT: "/v0/privilege/set-selected-privilege-default",
    API_UPDATE_PRIVILEGE: "/v0/privilege/update-features",
    API_UPDATE_DEFAULT_PRIVILEGE: "/v0/privilege/update-default-features"
})


module.config(function($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider
        .state('privilegeSettings', {
            parent: 'app',
            url: '/privilege/settings',
            views: {
                '@': {
                    template: privSettingsTpl,
                    controller: privSettingsCtrl,
                    controllerAs: 'privilegeSettings'
                }
            },
            params: {
                role_id: undefined,
                module_id: undefined

            }
        })
});

export default module


// WEBPACK FOOTER //
// ./src/app/privilege/privilegeModule.js